import { takeEvery, fork, put, all } from 'redux-saga/effects';
import { api, axiosInstance } from 'api';

// Login Redux States
import { GET_ALLOWED_ACTIONS, SIGNUP_USER } from './actionTypes';
import { apiError, setAllowedActions, signupUserSuccess } from './actions';
import { AllowedAction } from 'api';
import { AxiosResponse } from 'axios';
import { apiLoading, apiResError, apiResSuccess } from '../../actions';

export interface ISignUpPayload {
	payload: any;
	type: string;
}

function* signupUser({ payload }: ISignUpPayload) {
	yield put(apiLoading('Completing sign up...'));
	try {
		const response: AxiosResponse<any> = yield axiosInstance.post(
			'api/account/signup',
			payload
		);
		const result = response.data;
		console.debug('Signup result:' + result);
		if (result != null && result.username != null) {
			yield put(signupUserSuccess(result));
			yield put(apiResSuccess('Sign up done!'));
		} else {
			yield put(apiError('Sign up failed!'));
			yield put(apiResError('Sign up failed!'));
		}
	} catch (error: any) {
		yield put(apiError('Sign up failed!'));
		yield put(apiResError('Sign up failed!'));
	}
}

function* getAllowedActions() {
	try {
		const response: AxiosResponse<AllowedAction[]> =
			yield api.account.apiAccountGetAllowedActionsGet();
		yield put(setAllowedActions(response.data));
	} catch (error: any) {}
}

export function* watchUserSignUp() {
	yield takeEvery(SIGNUP_USER, signupUser);
}
export function* watchGetPermissions() {
	yield takeEvery(GET_ALLOWED_ACTIONS, getAllowedActions);
}

function* loginSaga() {
	yield all([fork(watchUserSignUp), fork(watchGetPermissions)]);
}

export default loginSaga;
